import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [{ screen: '(min-width: 1280px)', width: '60vw' }]

export default function LianaDesktop(): React.ReactElement {
  const { t } = useTranslation('drill')

  return (
    <ResponsiveImage
      alt={t('imageAlt.lianaDesktop')}
      fit="cover"
      height={727}
      imageClassName="absolute -top-44 -left-12 max-w-none w-[930px]"
      loading="eager"
      mediaQuery={mediaQuery}
      srcKey="math-drills/index/beanstalk-desktop.png"
      width={930}
    />
  )
}
